/* tslint:disable */

declare var Object: any;
export interface LeaseTerminationInterface {
  "lease_id": number;
  "tenant_lease_id": number;
  "exit_step": string;
  "exit_type": string;
  "lease_step_object": any;
  "user_id"?: number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class LeaseTermination implements LeaseTerminationInterface {
  "lease_id": number;
  "tenant_lease_id": number;
  "exit_step": string;
  "exit_type": string;
  "lease_step_object": any;
  "user_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: LeaseTerminationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaseTermination`.
   */
  public static getModelName() {
    return "LeaseTermination";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaseTermination for dynamic purposes.
  **/
  public static factory(data: LeaseTerminationInterface): LeaseTermination{
    return new LeaseTermination(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaseTermination',
      plural: 'LeaseTerminations',
      path: 'LeaseTerminations',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "tenant_lease_id": {
          name: 'tenant_lease_id',
          type: 'number'
        },
        "exit_step": {
          name: 'exit_step',
          type: 'string'
        },
        "exit_type": {
          name: 'exit_type',
          type: 'string',
          default: 'EXIT'
        },
        "lease_step_object": {
          name: 'lease_step_object',
          type: 'any'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
